import React, { Component, Fragment } from 'react'
import { Icon } from '@driftt/tide'
import DnDTable from 'components/DnDTable'
import { connect } from 'react-redux'

import EditCategoryIcon from 'images/edit_category_icon.svg'
import DeleteCategoryIcon from 'images/delete_category_icon.svg'

import { Sidebar } from '@driftt/tide'

import { bindActionCreators } from 'redux'
import { AdditionalArticlesColumns } from 'constants/Table'
import RowFormatter from 'constants/Table/rowFormatter'

import { TABLE_TYPE_CATEGORY } from '../EmptyTable/constants'
import {
  setSectionToEdit,
  clearSectionToEdit,
  setSectionToDelete,
  clearSectionToDelete,
  reorderCategoryDocuments,
  reorderCategorySections,
  setArticle,
  clearArticle
} from 'modules/knowledgebase/actions'

import { Link } from 'react-router-dom'

import EmptyTable from 'components/EmptyTable'
import EditSectionSidebarContent from 'components/SidebarContent/EditSectionSidebarContent'
import DeleteSectionModalContent from 'components/DeleteModalContent/DeleteSectionModalContent'
import DeleteArticleContent from 'components/DeleteModalContent/DeleteArticleContent'

import { getCategoryById, getUncategorizedDocuments, getSectionToDelete, getArticle } from 'modules/knowledgebase/selectors'
import moment from 'moment'

import './style.css'

const SECTIONS_TABLE_COLUMNS = [
  {
    label: '',
    width: '5px'
  },
  {
    label: 'Sections',
    width: '300px'
  },
  {
    label: '',
    width: '130px'
  },
  {
    label: 'Created',
    width: '120px'
  },
  {
    label: 'Updated',
    width: '120px'
  },
  {
    label: '',
    width: '50px'
  },
  {
    label: '',
    width: '100px'
  },
  {
    label: '',
    width: '5%'
  },
  {
    label: '',
    width: '10%'
  },
]

class Category extends Component {
  
  state = {
    isSidebarOpen: false,
    isModalOpen: false,
    deleteArticleModal: false
  }
  
  formatSection = (category, section, onEditSectionClick, onDeleteSectionClick) => {
    return {
      data: [
        {
          content: (<Icon name="hamburger"/>)
        },
        {
          content: (
            <Link
              className="category-article-name"
              to={`/category/${category.id}/${section.id}`}
            >
              <span className="category-section-title">{section.name}</span>
              <span className="category-section-article-count">
                {section.documents.length > 1 || section.documents.length === 0
                  ? `${section.documents.length} articles` : `${section.documents.length} article`}
              </span>
            </Link>
          )
        },
        {
          content: null
        },
        {
          content: <span className="section-created-date">{moment(section.createdAt).format('M/DD/YYYY')}</span>,
        },
        {
          content: <span className="section-updated-date">{moment(section.updatedAt).format('M/DD/YYYY')}</span>,
        },
        {
          content: null
        },
        {
          content: null
        },
        {
          content: (
            <img
              onClick={onEditSectionClick(section)}
              className="category-section-card-edit-icon"
              src={EditCategoryIcon}
              alt="Edit Article"/>
          )
        },
        {
          content: (
            <img
              onClick={onDeleteSectionClick(section)}
              className="category-section-article-delete-icon"
              src={DeleteCategoryIcon} alt="Delete Article"
            />
          )
        }
      ]
    }
  }
  
  handleDeleteArticleClick = article => () => {
    const { actions } = this.props
    actions.setArticle(article)
    
    this.setState({isModalOpen: true, deleteArticleModal: true})
  }
  
  getDataForArticlesTable = () =>
    this.props.category.documents.map(
      article => RowFormatter
        .ArticleTableRows(article, this.handleDeleteArticleClick)
  )
  
  getDataForSectionsTable = category => {
    return this.props.category.sections.map((section) => this.formatSection(category, section, this.handleEditSectionClick, this.handleDeleteSectionClick))
  }
  
  handleDeleteSectionClick = section => () => {
    const { actions } = this.props
    actions.setSectionToDelete(section)
    
    this.setState({isModalOpen: true})
  }
  
  handleEditSectionClick = section => () => {
    const { actions } = this.props
    actions.setSectionToEdit(section)
    
    this.setState({isSidebarOpen: true})
  }
  
  handleCloseSidebar = () => {
    const { actions } = this.props
    actions.clearSectionToEdit()
  
    this.setState({isSidebarOpen: false})
  }
  
  handleCloseModal = () => {
    const { actions } = this.props
    
    this.setState({isModalOpen: false, deleteArticleModal: false})
    actions.clearArticle()
  }
  
  handleArticleDragEnd = dropResult => {
    const { actions, category } = this.props
    
    if (!!dropResult.destination) {
      const event = {
        categoryId: category.id,
        sourceId: dropResult.draggableId,
        destinationId: category.documents[dropResult.destination.index].id,
        oldIndex: dropResult.source.index,
        newIndex: dropResult.destination.index
      }
  
      actions.reorderCategoryDocuments(event)
    }
  }
  
  handleSectionDragEnd = dropResult => {
    const { actions, category } = this.props
    
    if (!!dropResult.destination) {
      const event = {
        categoryId: category.id,
        sourceId: dropResult.draggableId,
        destinationId: category.sections[dropResult.destination.index].id,
        oldIndex: dropResult.source.index,
        newIndex: dropResult.destination.index
      }
      
      actions.reorderCategorySections(event)
    }
  }
  
  render() {
    const { category, sectionToDelete } = this.props
    const { isSidebarOpen, isModalOpen, deleteArticleModal } = this.state
    const showEmptyState = category ? category.documents.length === 0 && category.sections.length === 0 : false
    
    return (
      <div className="category-section-wrapper">
        <div className="categories-name-and-description-wrapper">
          <Icon name="categories-2"/>
          <h2 className="category-name">{category.name}</h2>
          {category.description.length > 0 &&
            <Fragment>
              <h3 className="category-section-description">{`Category description: ${category.description}`}</h3>
              <hr className="category-hr"/>
            </Fragment>
          }
        </div>
  
        {category.sections.length > 0 &&
          <DnDTable
            className="category-section-table-sections"
            columns={SECTIONS_TABLE_COLUMNS}
            isDraggable
            draggableObjects={category.sections}
            data={this.getDataForSectionsTable(category)}
            onDragEnd={this.handleSectionDragEnd}
          />
        }
  
        {(showEmptyState || category.documents.length > 0) &&
          <DnDTable
            isDraggable
            draggableObjects={category.documents}
            className="category-section-table-articles"
            columns={AdditionalArticlesColumns}
            data={this.getDataForArticlesTable()}
            onDragEnd={this.handleArticleDragEnd}
          />
        }
        
        {showEmptyState && <EmptyTable {...this.props} tableType={TABLE_TYPE_CATEGORY}/>}
        
        {sectionToDelete.name && isModalOpen &&
          <DeleteSectionModalContent onCloseModal={this.handleCloseModal}/>}
        {deleteArticleModal && isModalOpen &&
          <DeleteArticleContent onCloseModal={this.handleCloseModal} />}
        
        <Sidebar
          className="category-section-sidebar"
          isOpen={isSidebarOpen}
          showClose
          close={this.handleCloseSidebar}
        >
          <EditSectionSidebarContent onCloseSidebar={this.handleCloseSidebar} />
        </Sidebar>
      </div>
    )
  }
}

const mapStateToProps = (state, props) => ({
  category: getCategoryById(state, { categoryId: parseInt(props.match.params.categoryId, 10) }),
  uncategorizedDocuments: getUncategorizedDocuments(state, { id: parseInt(props.match.params.categoryId, 10) }),
  sectionToDelete: getSectionToDelete(state),
  article: getArticle(state)
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    setArticle,
    clearArticle,
    setSectionToEdit,
    reorderCategoryDocuments,
    reorderCategorySections,
    clearSectionToEdit,
    setSectionToDelete,
    clearSectionToDelete
  }, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(Category)